import { z } from 'zod';

/**
 * Phone — CLIENT-SIDE FORMAT FEEDBACK ONLY.
 *
 * One HaloPSA contact/site phone field shape is reused across four unrelated forms (sign-up,
 * billing details, profile, Team page add/edit user). Was previously pasted into each schema
 * independently — extracted here after a SonarQube duplication finding so the rule can't drift
 * between copies again (e.g. `max` bumped in one place only).
 *
 * The server always re-validates on submit; if this mirror is ever out of step, the only cost
 * is UX, never a bad write.
 */

/** Digits, whitespace, and `- + ( )` only. Empty string is allowed — the field is optional. */
export const PHONE_REGEX = /^[0-9\s\-+()]*$/;

/** Max length shared by every phone field using this rule. */
export const MAX_PHONE_LENGTH = 20;

/** Optional phone string field: format-checked only when non-empty. */
export const phoneSchema = z
  .string()
  .regex(PHONE_REGEX, 'Invalid phone number format.')
  .max(MAX_PHONE_LENGTH, `Phone number too long (max ${MAX_PHONE_LENGTH} characters).`)
  .optional()
  .or(z.literal(''));
